<template>
  <div class="content-container">
    <search-comp @onSearch="attachData()" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelId"
                    :multiple="true"
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Từ ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo dự báo đặt phòng theo tuần</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid1"
              :columns="columns"
              :auto-select-first-row="false"
              :row-multi-select-with-click="true"
              dom-layout="scroll"
              :rows="rows"
              class="agGrid"
              :auto-size-cell="true"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Ngày: Hiển thị thứ, ngày trong khoảng thời gian được tìm kiếm
            </li>
            <li>
              Check-in Phòng: Hiển thị số lượng phòng đã đặt sẽ được checkin
              trong ngày
            </li>
            <li>
              Check-in Khách: Hiển thị số lượng khách đã đặt sẽ được checkin
              trong ngày
            </li>
            <li>
              Check-out Phòng: Hiển thị số lượng phòng đã đặt sẽ được checkout
              trong ngày
            </li>
            <li>
              Check-out Khách: Hiển thị số lượng khách đã đặt sẽ được checkout
              trong ngày
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import InfoBtn from './components/InfoBtn'
import { getSourceApi } from '@/api/Statistics/source'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import { getListFreeRoom } from '@/api/report_service/freeRoomReport'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import {
  getListRevenueWeekly,
  getListRevenueWeeklyExcel
} from '@/api/report_service/revenueWeeklyReport'
export default {
  components: {
    SingleCalendar,
    SelectWithSearchTable,
    CalendarRange,
    InfoBtn
  },
  data() {
    return {
      maxDate: this.$moment().format('YYYY-MM-DD'),
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().add(7, 'days').format('YYYY-MM-DD')
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().add(7, 'days').format('YYYY-MM-DD')
      },
      dialogFormVisible: false,
      hotelList: [],
      loading: false,
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().add(6, 'days').format('YYYY-MM-DD'),
        hotelId: ''
      },
      defaultSearchParams: {
        ddateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().add(6, 'days').format('YYYY-MM-DD'),
        hotelId: ''
      },

      columns: [
        {
          headerName: 'Thứ',
          field: 'weekDays',
          minWidth: 200,
          sortable: false
        },
        {
          headerName: 'Ngày',
          field: 'date',
          valueGetter: params => {
            return this.$displayDate(params.data.date)
          },
          minWidth: 200,
          sortable: false
        },

        {
          headerName: 'Check in',
          headerClass: [
            'header-cell-suffix-group',
            'header-group-cell-divide',
            'header-cell-center'
          ],
          // maxWidth: 200,
          marryChildren: true,
          children: [
            {
              field: 'total_room_check_in',
              headerName: 'Phòng',
              sortable: false
            },
            {
              field: 'total_guest_check_in',
              headerName: 'Khách',
              sortable: false
            }
          ]
        },
        {
          headerName: 'Check out',
          // maxWidth: 200,
          headerClass: [
            'header-cell-suffix-group',
            'header-group-cell-divide',
            'header-cell-center'
          ],
          marryChildren: true,
          children: [
            {
              field: 'total_room_check_out',
              headerName: 'Phòng',
              sortable: false
            },
            {
              field: 'total_guest_check_out',
              headerName: 'Khách',
              sortable: false
            }
          ]
        }
      ],
      rows: []
    }
  },
  created() {
    this.getListHotel()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      if (cmmd == 'pdf') {
      }
      if (cmmd == 'excel') {
        getListRevenueWeeklyExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'bao_cao_du_bao_dat_phong_theo_tuan_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },

    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    async attachData() {
      // this.loading = true
      const dayofWeek = [
        'Chủ nhật',
        'Thứ hai',
        'Thứ ba',
        'Thứ tư',
        'Thứ năm',
        'Thứ sáu',
        'Thứ bảy'
      ]
      const data = await getListRevenueWeekly(this.searchParams)
      // this.loading = false
      this.rows = data.data
      this.rows.forEach(item => {
        item.weekDays = dayofWeek[this.$moment(item.date).isoWeekday() % 7]
      })

      // this.rows = data.data
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
</style>
